import { useMutation, useQueryClient } from '@tanstack/react-query';

import * as Api from 'contracts/api';
import { RequestAgent } from 'modules/request-agent';
import { useNotify } from 'pages/components/SnackBarProvider';
import { UseExposedMutationOptions } from 'queries/types';

export function useSetDefaultLicense(
    options?: UseExposedMutationOptions<Api.V4.User.DefaultLicense.Response, Error, Api.V4.User.DefaultLicense.Payload>
) {
    const notify = useNotify();
    const queryClient = useQueryClient();

    return useMutation<Api.V4.User.DefaultLicense.Response, Error, Api.V4.User.DefaultLicense.Payload>({
        ...options,
        mutationFn: async (body) => {
            await new RequestAgent().public.post(Api.V4.User.DefaultLicense.Endpoint(), { body });
            queryClient.setQueryData<Api.V4.User.Info.Response>(Api.V4.User.Info.QueryKey(), (cached) => {
                return cached ? { ...cached, defaultLicenseId: body.licenseId } : cached;
            });
        },
        onError: (error, ...rest) => {
            notify.openNotification({ level: 'error', message: error.message });
            options?.onError?.(error, ...rest);
        }
    });
}
